import type { ApprovalOddsState } from '../types/approvalOdds';

/**
 * Derives the display status of approval odds from the user's state.
 * - `isLocked`: odds are hidden behind an unlock action (anything other than
 *   `fresh` or `expired`, including a missing state).
 * - `isFresh`: odds are up to date and shown at full opacity.
 */
export const getApprovalOddsStatus = (state?: ApprovalOddsState) => {
  const isFresh = state === 'fresh';
  const isLocked = !state || !['expired', 'fresh'].includes(state);

  return { isLocked, isFresh };
};
